import React from 'react';

import { PanelContainer } from '../panel-container/panel-container';
import { PanelContent } from '../panel-content/panel-content';
import { PanelBodySkeleton } from './panel-body-skeleton';
import { PanelHeaderSkeleton } from './panel-header-skeleton';
import { PanelSubheaderSkeleton } from './panel-subheader-skeleton';

export function PanelSkeleton(): JSX.Element {
	return (
		<PanelContainer testId="panel-container-skeleton" aria-label="Loading">
			<PanelHeaderSkeleton shouldShowIcon actionsCount={1} />
			<PanelContent>
				<PanelSubheaderSkeleton />
				<PanelBodySkeleton />
			</PanelContent>
		</PanelContainer>
	);
}
